import { ENABLE_LCA_FACILITIES_PROTOTYPE_UI } from "../config/constants";
import FacilityListNew from "../screens/facility/facilityList/FacilityListNew";
import FacilityList from "../screens/facility/facilityList/legacy/FacilityList";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";

const FacilityGrid = ENABLE_LCA_FACILITIES_PROTOTYPE_UI ? <FacilityListNew /> : <FacilityList />;

export const FacilityRoutes = [
  {
    path: "/facility",
    route: FacilityGrid,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess]
  }
];
